<div class="otp-wrap" [formGroup]="form">
  <h3>OTP Verification</h3>

  @if (otpSent) {
    <p class="otp-sub">{{ subHeader }}</p>
  } @else {
    <div class="otp-input-row">
      <p-message
        severity="warn"
        [text]="otpMessage || 'OTP could not be sent. Contact support.'"
      />
    </div>
  }

  <div class="otp-input-row">
    <p-inputotp formControlName="code" [length]="6" [integerOnly]="true" />
  </div>

  @if (otpSent) {
    <div class="otp-meta">
      @if (expired) {
        <span class="expiry expired">OTP expired — tap Resend.</span>
      } @else {
        <span class="expiry">Expires in {{ countdown }}</span>
      }
    </div>
  }

  <div class="actions">
    <p-button
      label="Verify"
      (onClick)="verify()"
      [loading]="verifying"
      [disabled]="!canVerify()"
    />
    <p-button
      [label]="cooldown > 0 ? 'Resend in ' + cooldown + 's' : 'Resend OTP'"
      [text]="true"
      [disabled]="cooldown > 0"
      (onClick)="resend()"
    />
  </div>
</div>
